import { render, staticRenderFns } from "./slik-table.vue?vue&type=template&id=d615a198"
import script from "./slik-table.vue?vue&type=script&lang=js"
export * from "./slik-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports